<template>
  <div :class="['vehicle-selector', { 'element--is-loading': !context.initialized.value }]">
    <template v-if="context.initialized.value">
      <oie-vehicle-selector-section
        v-for="(val, key) in context.nodeData.value"
        :id="`section-${key}`"
        :key="val.node.code"
        :level="key"
        :context="context"
        :use-links="true"
        :hide-others="true"
        @select="handleSelection($event, key)"></oie-vehicle-selector-section>
      <div v-if="shouldShowExtendedInfo" class="vehicle-selector__extended-info text-formatter">
        <h2 class="vehicle-selector__extended-info-heading" v-html="channelNodeExtendedInformationHeading"></h2>
        <p class="vehicle-selector__extended-info-text" v-html="channelNodeExtendedInformation"></p>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, onMounted, nextTick, computed, ref } from '@vue/composition-api'
import useNodeData from '@/composables/useNodeData'
import utils from '@/core/utils'
import httpService from '@/core/http-service'

export default defineComponent({
  setup(_, { root }) {
    const context = useNodeData(root.clientModel.selectedVehicleHierarchy)

    const shouldShowExtendedInfo = computed(() => {
      return (root.clientModel.channelNodeExtendedInformationHeading || root.clientModel.channelNodeExtendedInformation) && context.lastLevel.value === '0'
    })

    const channelNodeExtendedInformationHeading = computed(() => ref(root.clientModel.channelNodeExtendedInformationHeading).value)
    const channelNodeExtendedInformation = computed(() => ref(root.clientModel.channelNodeExtendedInformation).value)

    const handleSelection = async (node, key) => {
      root.$store.dispatch('ui/toggleValue', {
        key: 'openNodeInformationLevel',
        data: null
      })
      await context.addLevel(node, key)
      updateUrlAndBreadcrumb(node)
      focusNextSection(key)
    }

    const updateUrlAndBreadcrumb = (node) => {
      utils.pushState(node.url)
      httpService.get(`vehicle/breadcrumb/${node.code}`).then(({ data }) => {
        root.publish('breadcrumb.update', data.breadCrumbList)
      })
    }

    const focusNextSection = async (currentLevel) => {
      const nextLevel = Number(currentLevel) + 1
      await nextTick()
      const el = document.getElementById(`section-${nextLevel}`)
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      if (el && !prefersReducedMotion) {
        root.$scrollTo(el, 700, {
          offset: root.mq('to-medium') ? -70 : -350
        })
        await nextTick()
        el.focus()
      }
    }

    onMounted(() => {
      context.initializeNodeData()
    })

    return {
      context,
      handleSelection,
      channelNodeExtendedInformationHeading,
      channelNodeExtendedInformation,
      shouldShowExtendedInfo
    }
  }
})
</script>

<style lang="scss">
.vehicle-selector {
  @include container;
  position: relative;
  min-height: 15rem;
}

.vehicle-selector > *:first-child {
  margin-top: measure(double);
}

.vehicle-selector > *:not(:last-child) {
  margin-bottom: measure(double);
}

.vehicle-selector__extended-info {
  margin-top: measure(half);
}

.vehicle-selector__extended-info-heading {
  margin-bottom: measure(quarter);
}

.vehicle-selector__extended-info-text {
  margin: 0;
}
</style>
